import { render, staticRenderFns } from "./OldmanLeave.vue?vue&type=template&id=5765834a&scoped=true"
import script from "./OldmanLeave.vue?vue&type=script&lang=js"
export * from "./OldmanLeave.vue?vue&type=script&lang=js"
import style0 from "./OldmanLeave.vue?vue&type=style&index=0&id=5765834a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5765834a",
  null
  
)

export default component.exports